"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Branch extends Parse.Object {
    constructor(attributes) {
        super('Branch', attributes);
    }
    get name() { return this.get('name'); }
    set name(value) { this.set('name', value); }
    get addressLine1() { return this.get('addressLine1'); }
    set addressLine1(value) { this.set('addressLine1', value); }
    get addressLine2() { return this.get('addressLine2'); }
    set addressLine2(value) { this.set('addressLine2', value); }
    get number() { return this.get('number'); }
    set number(value) { this.set('number', value); }
    get suburb() { return this.get('suburb'); }
    set suburb(value) { this.set('suburb', value); }
    get city() { return this.get('city'); }
    set city(value) { this.set('city', value); }
    get addressState() { return this.get('addressState'); }
    set addressState(value) { this.set('addressState', value); }
    get country() { return this.get('country'); }
    set country(value) { this.set('country', value); }
    get zip() { return this.get('zip'); }
    set zip(value) { this.set('zip', value); }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get tradingHours() {
        return this.get('tradingHours');
    }
    set tradingHours(value) {
        this.set('tradingHours', value);
    }
    get canonicalSearch() { return this.get('canonicalSearch'); }
    set canonicalSearch(value) { this.set('canonicalSearch', value); }
    get phone() { return this.get('phone'); }
    set phone(value) { this.set('phone', value); }
    get identificator() { return this.get('identificator'); }
    set identificator(value) { this.set('identificator', value); }
    get deliveryDistance() { return this.get('deliveryDistance'); }
    set deliveryDistance(value) { this.set('deliveryDistance', value); }
    get team() { return this.get('team'); }
    set team(value) { this.set('team', value); }
}
exports.Branch = Branch;
Parse.Object.registerSubclass('Branch', Branch);
//# sourceMappingURL=Branch.js.map